<template>
 <div class="footer">
 
     <div class="content">
           <span>
            上饶美术馆版权所有
          </span>
          <span>
                工信部备案号：**************
          </span>
     </div>
   

   
 </div>
</template>

<script>
export default {
  name: 'indexFooter',
  props: {
  },
   data() {
      return {
    
      };
    },
  mounted:function(){
  },
  methods:{

      
  }
}
</script>


<style scoped>
     .footer {
       /* position: fixed;
           bottom: 0px; */
       width: 100%;
       height:0.833333rem /* 60px -> 0.833333rem */;
       background-color: rgba(183,140,13, 0.6);

     }

     .footer .content {
          display: flex;
              width: 100%;
          height: 100%;
          align-items: center;
          justify-content: center;
          color: #222222;
          font-size: 0.25rem /* 18px -> 0.25rem */;
          font-family: SourceHanSansCN-;
          font-weight: 400;
     }
       .footer .content >span {
          margin-right:0.347222rem /* 25px -> 0.347222rem */;
       }
</style>
